import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Portfolio from "./pages/Portfolio";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Expertise from "./pages/Expertise";
import Timeline from "./pages/Timeline";
import Contact from "./pages/Contact";
import SigmaHQ from "./pages/SigmaHQ";

// Wrapper to conditionally show Header/Footer based on route
const Layout = ({ children }) => {
  const location = useLocation();
  const isGeneratedPortfolio = location.pathname.startsWith('/p/');

  return (
    <>
      {!isGeneratedPortfolio && <Header />}
      <main className="min-h-screen">{children}</main>
      {!isGeneratedPortfolio && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/expertise" element={<Expertise />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sigma-hq" element={<SigmaHQ />} />
            <Route path="/tech-innovation" element={<SigmaHQ />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
